import React from 'react';

type Props = React.HTMLProps<HTMLParagraphElement>;

const Paragraph: React.FC<Props> = ({ children, className, ...rest }) => {
  return (
    <p className={`typography_paragraph ${className}`} {...rest}>
      {children}
    </p>
  );
};

export default Paragraph;
